export function benchmarkMethod(): number {
  let x = 0;
  for (let i = 0; i < 1000; i++) {
    x += Math.sin(Math.sqrt(Math.pow(i, 3) + Math.pow(i, 2) + i));
    x -= Math.cos(Math.log(i + 1) * Math.exp(Math.sqrt(i)));
    x *= Math.tan(1 / (i + 1));
  }
  return x;
}
